import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { suretyKeys } from "@/lib/query-keys";
import type { SuretyPanel } from "@/types/surety";

/** El panel de la cartera para un mes (`AAAA-MM`); sin mes, el actual. */
export function useSuretyPanel(month?: string) {
  return useQuery({
    queryKey: suretyKeys.panel(month),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: SuretyPanel }>(
        `/surety/panel${month ? `?month=${month}` : ""}`,
      );
      return res.data;
    },
  });
}
